export default "__VITE_ASSET__BsEnjuh4__"